<mat-expansion-panel [id]="panelId" class="main-panel mt-3 overflow-visible" (opened)="handleOpened()" (closed)="handleClosed()" hideToggle="true"
  [expanded]="panelOpenState">
  <mat-expansion-panel-header tabindex="0" [attr.aria-label]="panel.title + (panelOpenState ? ', expanded' : ', collapsed')" [style.background-color]="panel.color" [collapsedHeight]="'auto'" [expandedHeight]="'auto'" class="main-header taxanomy-header p-0 mb-2">
    <mat-panel-title class="align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <img *ngIf="image"
             [class]="config.categoryImagesShape?.applyRoundImages ? 'taxanomy-img taxanomy-img-round' : 'taxanomy-img'"
             [style.border-color]="config.categoryImagesShape?.applyRoundImages ? panel.color : 'transparent'"
             [src]="image"
             [alt]="imageAlt ? imageAlt : 'Category image'"
             loading="lazy">
        <div *ngIf="!image" class="image-place-holder"></div>
        <h3>{{panel.title}}</h3>
      </div>
      <div class="arrows" tabindex="0" role="button" [attr.aria-label]="(panelOpenState ? 'Collapse' : 'Expand') + ' ' + panel.title" (keydown)="onArrowKeydown($event)">
        <img class="taxanomy-arrow-up" *ngIf="panelOpenState"
        src="../../../../../assets/action-plan-icons/Arrow@2x.png" alt="" loading="lazy">
        <img class="taxanomy-arrow-down" *ngIf="!panelOpenState"
        src="../../../../../assets/action-plan-icons/ArrowDown@2x.png" alt="" loading="lazy">
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <kla-new-action-taxonomy-goals *ngFor="let goal of panel.list" [goal]="goal" [color]="panel.color" [isParentOpen]="panelOpenState" [config]="config" [parentCategoryTitle]="panel.title">
  </kla-new-action-taxonomy-goals>
</mat-expansion-panel>

